import { ChevronRight } from 'lucide-react';
import Link from 'next/link';

export interface BreadCumbNode {
  title?: string;
  link?: string;
}

export interface BreadCumbProps {
  nodes: BreadCumbNode[];
}

export default function BreadCumb({ nodes = [] }: BreadCumbProps) {
  return (
    <nav aria-label="breadcrumb" className="py-3">
      <ol className="flex flex-wrap items-center text-sm">
        {nodes.map((node, index) => (
          <li key={`breadcrumb.${index}`} className="flex items-center">
            {index !== 0 && (
              <ChevronRight className="mx-2 size-4 text-gray-400" />
            )}
            {node.link ? (
              <Link
                href={node.link}
                className="font-medium text-gray-600 transition-colors duration-200 hover:text-primary-600"
              >
                {node.title}
              </Link>
            ) : (
              <span className="max-w-[200px] truncate font-medium text-gray-900">
                {node.title}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
